import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function Footer() {
  const mainCategories = categories.slice(0, 7);
  const moreCategories = categories.slice(7);

  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          <div>
            <h3 className="font-heading text-xl font-bold text-white mb-4">CSSSpreadsheet</h3>
            <p className="text-sm text-background-300 leading-relaxed mb-6">
              The largest CSSBuy Spreadsheet directory for 2026. Discover thousands of verified fashion finds, sneakers, accessories, luxury items, and trusted sellers through the most comprehensive spreadsheet online.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-accent-500 transition-colors duration-200"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-accent-500 transition-colors duration-200"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a
                href="https://reddit.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100/10 hover:bg-accent-500 transition-colors duration-200"
                aria-label="Reddit"
              >
                <i className="ri-reddit-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-wider text-background-400 mb-5 font-semibold">Categories</h4>
            <ul className="space-y-2.5">
              {mainCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-150"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-wider text-background-400 mb-5 font-semibold">More Categories</h4>
            <ul className="space-y-2.5">
              {moreCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-150"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-wider text-background-400 mb-5 font-semibold">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-150">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/article/cssbuy-spreadsheet-guide" className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-150">
                  CSSBuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-150"
                >
                  Main Store
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-100/10 pt-10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-400">
            <p>&copy; {new Date().getFullYear()} CSSSpreadsheet.skin — All rights reserved.</p>
            <div className="flex items-center gap-6">
              <a href="/" className="hover:text-background-200 transition-colors">Privacy Policy</a>
              <a href="/" className="hover:text-background-200 transition-colors">Terms of Service</a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="hover:text-accent-400 transition-colors font-medium"
              >
                Visit Main Store →
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full overflow-hidden border-t border-background-100/5">
        <div className="text-[12vw] md:text-[10vw] font-heading font-extrabold text-background-100/[0.03] leading-none tracking-tighter text-center py-8 select-none">
          CSSBUY SPREADSHEET
        </div>
      </div>
    </footer>
  );
}